import * as types from '../../../../types/masters/styles/caratage/caratageTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingCaratage: null,
};

const caratageReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_CARATAGE_REQUEST:
    case types.ADD_CARATAGE_REQUEST:
    case types.UPDATE_CARATAGE_REQUEST:
    case types.DELETE_CARATAGE_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_CARATAGE_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case types.ADD_CARATAGE_SUCCESS:
    case types.UPDATE_CARATAGE_SUCCESS:
    case types.DELETE_CARATAGE_SUCCESS:
      return { ...state, loading: false, error: null };
    case types.FETCH_CARATAGE_FAILURE:
    case types.ADD_CARATAGE_FAILURE:
    case types.UPDATE_CARATAGE_FAILURE:
    case types.DELETE_CARATAGE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case types.SET_CARATAGE_EDIT:
      return { ...state, editingCaratage: action.payload };
    case types.CLEAR_CARATAGE_EDIT:
      return { ...state, editingCaratage: null };
    default:
      return state;
  }
};

export default caratageReducer; 